import React from 'react';
import Button from '../global/button';
import TranslatedCopy from '../../intl/translated-copy';
import Pictogram from '../global/pictogram';
import { enrollmentServiceErrorSuccess } from '../../../redux/actions';

const UserProfileRegistrationDuplicateInfo = (props) => {
  const {
    dispatch,
    handleActiveRegistration,
  } = props;

  const handleBtnClick = () => {
    dispatch(enrollmentServiceErrorSuccess());
    handleActiveRegistration();
  };

  return (
    <div className='UserProfileRegistrationduplicateInfo-container'>
      <button
        className='backButton'
        onClick={ ()=> handleBtnClick() } >
        <span className='Icon Icon--calendarArrowLeft' />
        <TranslatedCopy
          className='copy-backButton'
          copyID='CC_TO_RETURN' />
      </button>
      <div className='body'>
        <Pictogram
          className='Icon'
          id='dataUserWarning'/>
        <TranslatedCopy
          className='duplicateInfo-title'
          copyID='PRO_HOME2.0_ERROR_DATA_USER_TITLE' />
        <TranslatedCopy
          className='duplicateInfo-subtitle'
          copyID='PRO_HOME2.0_ERROR_DATA_USER_DESCRIPTION' />
      </div>
      <Button
        className='Btn'
        copyID={ 'CC_RETRY' }
        onBtnClick={ ()=> handleBtnClick()} />
    </div>
  );
};

export default UserProfileRegistrationDuplicateInfo;